module.exports = __webpack_public_path__ + "img/banner_itemtwo_downimg.4a4640c0.png";